import {VStack, Text, Box} from "@chakra-ui/react";

export function DiscontinuedBanner() {
    return (
        <VStack
            spacing="16px"
            marginTop={["32px", "48px", "64px"]}
            marginBottom={["32px", "48px", "64px"]}
            marginLeft={["4%", "10%", "16%", "22%"]}
            marginRight={["4%", "10%", "16%", "22%"]}
            align="left"
        >
            <Box
                backgroundColor="red"
                padding="20px"
                borderRadius="lg"
                shadow="md"
            >
                <VStack
                    spacing="12px"
                    align="left"
                >
                    <Text
                        fontSize={["2xl", "3xl", "4xl"]}
                        fontWeight="bold"
                        color="white"
                    >
                        Game Discontinued
                    </Text>
                    <Text
                        fontSize="lg"
                        color="white"
                    >
                        Mafia: The Game has been discontinued and is no longer available to play. Thank you to everyone who played and supported the game.
                    </Text>
                </VStack>
            </Box>
        </VStack>
    );
}
